import axios from "axios";
import { getBaseURLforBackEnd  , getConfigAxios } from '@/utils.js'
import master_data from "./master_data";


export default {
    namespaced: true,
    state: {
        arrDVM : [],
        dvmSelected : null,
        dvmAutocomplete : '',


        arrUsers : [],
        userSelected : null,
        userAutoComplete : '',


        // labNoToEdit : "",
        opdSelected : {} ,
                // {
                //     "address":"N/A"  ,
                //     "age":"N/A" ,
                //     "birth":"N/A" ,
                //     "breed":"N/A" ,
                //     "date_rec":"N/A" ,
                //     "idopd":"N/A" ,
                //     "idown":"N/A" ,
                //     "name":"N/A" ,
                //     "owner_name":"N/A" ,
                //     "phone_mobile":"N/A" ,
                //     "sex":"N/A" ,
                //     "species":"N/A" ,
                //     "species_id":"N/A" ,
                //     "visit_active":"N/A" ,
                // } 
                            //       opdSelected :{
                            //         "address":"191/24  ห้วยกะปิ   เมืองชลบุรี   ชลบุรี"  ,
                            //         "age":"8 Y 9 M 29 D",
                            //         "birth":"2013-10-06",
                            //         "breed":"SHIH TZU",
                            //         "date_rec":"2022-01-02",
                            //         "idopd":"65000092",
                            //         "idown":"WN6500066",
                            //         "name":"แคสเปอร์   (N)",
                            //         "owner_name":"ภัทรกันย์   ศิวัฒม์ธนาโชติ",
                            //         "phone_mobile":"0972979578",
                            //         "sex":"M",
                            //         "species":"สุนัข",
                            //         "species_id":1,
                            //         "visit_active":null,
                            // }
        // labParam : [] ,
        blMor : [] ,
        blMorSelected : [] ,


        blParasiteParam :[],
        blParasiteMaterSelect :[],
        blParasiteMaterSelected : '', 
        blParasiteDetailSelected : [], 
        
        
        UAParams : [],


        lab_HIS_LIS_Mapping : [],

        dataModelMNLABAutomate : [],
        

        UAExtend : [],


        
        commentNote : "",
        singni_phy: "",
        tentative_dx : "",
        test_desire : "",
        special_rq : "",

        diagnosisNote : "",
        resultRemark : "",

        CBCImages : [],

        modeManuallyLabAutomate : 0 , // 0 == new insert , 1 == edit mode

        dataToEdit_ManuallyLabAutomate : {}, // care with modeManuallyLabAutomate == 1

        mapGroupName_From_Key :{
                                "hm":"Hematology",
                                "bf":"Body fluid",
                                "chemistry":"Chemistry",
                                "hormone":"Hormones",
                                "blood_gas":"Blood gas",
                                "outlab":"Out lab",
                                "blmor":"Blood morphology",
                                },

        mapField_Fullname : [
                                {
                                "field_name": "hm_wbc",
                                "nick_name" : "WBC",
                                "full_name" : "White blood cell count"
                                },
                                {
                                "field_name": "hm_segs",
                                "nick_name" : "NEUT %",
                                "full_name" : "Percent Neutrophil count"
                                },
                                {
                                "field_name": "hm_lymph",
                                "nick_name" : "LYMPH %",
                                "full_name" : "Percent Lymphocyte count"
                                },
                                {
                                "field_name": "hm_mono",
                                "nick_name" : "MONO %",
                                "full_name" : "Percent Monocyte count"
                                },
                                {
                                "field_name": "hm_eos",
                                "nick_name" : "EO %",
                                "full_name" : "Percent Eosinophil count"
                                },
                                {
                                "field_name": "hm_baso",
                                "nick_name" : "BASO %",
                                "full_name" : "Percent Basophil count"
                                },
                                {
                                "field_name": "hm_neut",
                                "nick_name" : "NEUT #",
                                "full_name" : "Number of Neutrophils"
                                },
                                {
                                "field_name": "hm_lymph1",
                                "nick_name" : "LYMPH# ",
                                "full_name" : "Number of Lymphocytes"
                                },
                                {
                                "field_name": "hm_mono1",
                                "nick_name" : "MONO # ",
                                "full_name" : "Number of Monocytes"
                                },
                                {
                                "field_name": "hm_eo",
                                "nick_name" : "EO #",
                                "full_name" : "Number of Eosinophils"
                                },
                                {
                                "field_name": "hm_baso1",
                                "nick_name" : "BASO # ",
                                "full_name" : "Number of Basophils"
                                },
                                {
                                "field_name": "hm_nucl_rbc",
                                "nick_name" : "NRBC % ",
                                "full_name" : "Percent of nucleated red blood cells"
                                },
                                {
                                "field_name": "hm_nrbc",
                                "nick_name" : "NRBC #  ",
                                "full_name" : "Number of nucleated red blood cells"
                                },
                                {
                                "field_name": "hm_my_cyte",
                                "nick_name" : "MY CYTE  ",
                                "full_name" : "Myelocyte"
                                },
                                {
                                "field_name": "hm_meta",
                                "nick_name" : "META",
                                "full_name" : "Metamyelocyte"
                                },
                                {
                                "field_name": "hm_blascell",
                                "nick_name" : "Blast cell",
                                "full_name" : "Blast cell"
                                },
                                {
                                "field_name": "hm_mastcell",
                                "nick_name" : "Mast cell",
                                "full_name" : "Mast cell"
                                },
                                {
                                "field_name": "hm_band",
                                "nick_name" : "Band",
                                "full_name" : "Band neutrophil"
                                },
                                {
                                "field_name": "hm_unclass",
                                "nick_name" : "UNCLASS",
                                "full_name" : "Unclassified"
                                },
                                {
                                "field_name": "hm_rbc",
                                "nick_name" : "RBC",
                                "full_name" : "Total number of red blood cell"
                                },
                                {
                                "field_name": "hm_hgb",
                                "nick_name" : "HGB",
                                "full_name" : "Hemoglobin concentration"
                                },
                                {
                                "field_name": "hm_pcv",
                                "nick_name" : "HCT",
                                "full_name" : "Hematocrit value"
                                },
                                {
                                "field_name": "hm_pcv1",
                                "nick_name" : "PCV ปั่น",
                                "full_name" : "Packed cell volume"
                                },
                                {
                                "field_name": "hm_mcv",
                                "nick_name" : "MCV",
                                "full_name" : "Mean corpuscular volume"
                                },
                                {
                                "field_name": "hm_mch",
                                "nick_name" : "MCH",
                                "full_name" : "Mean  corpuscular hemoglobin"
                                },
                                {
                                "field_name": "hm_mchc",
                                "nick_name" : "MCHC",
                                "full_name" : "Mean corpuscular hemoglobin concentration"
                                },
                                {
                                "field_name": "hm_rdw",
                                "nick_name" : "RDW-SD",
                                "full_name" : "Red Cell Distribution Width (standard deviation)"
                                },
                                {
                                "field_name": "hm_rdwcv",
                                "nick_name" : "RDW-CV",
                                "full_name" : "Red Cell Distribution Width (coefficient of variation)"
                                },
                                {
                                "field_name": "hm_plti",
                                "nick_name" : "PLT - I",
                                "full_name" : "Platelet Impedant"
                                },
                                {
                                "field_name": "hm_plto",
                                "nick_name" : "PLT - O",
                                "full_name" : "Platelet Optical"
                                },
                                {
                                "field_name": "hm_platelets",
                                "nick_name" : "PLT",
                                "full_name" : "Platelets"
                                },
                                {
                                "field_name": "hm_estimatedplt",
                                "nick_name" : "Est. PLT count/uL",
                                "full_name" : "Platelet count estimates from blood smear examination"
                                },                                 
                                {
                                "field_name": "hm_mpv",
                                "nick_name" : "MPV",
                                "full_name" : "Mean platelet volume"
                                },
                                {
                                "field_name": "hm_pdw",
                                "nick_name" : "PDW",
                                "full_name" : "Platelet distribution width"
                                },
                                {
                                "field_name": "hm_plcr",
                                "nick_name" : "P-LCR",
                                "full_name" : "Platelet-large cell ratio"
                                },
                                {
                                "field_name": "hm_pct",
                                "nick_name" : "PCT",
                                "full_name" : "Plateletcrit"
                                },
                                {
                                "field_name": "hm_retics",
                                "nick_name" : "RET% ",
                                "full_name" : "Reticulocyte percent"
                                },
                                {
                                "field_name": "hm_ret1",
                                "nick_name" : "RET# ",
                                "full_name" : "Reticulocyte count"
                                },
                                {
                                "field_name": "hm_irf",
                                "nick_name" : "IRF",
                                "full_name" : "Immature reticulocyte fraction"
                                },
                                {
                                "field_name": "hm_lfr",
                                "nick_name" : "LFR",
                                "full_name" : "Low fluorescence ratio"
                                },
                                {
                                "field_name": "hm_mfr",
                                "nick_name" : "MFR",
                                "full_name" : "Medium fluorescence ratio"
                                },
                                {
                                "field_name": "hm_hfr",
                                "nick_name" : "HFR",
                                "full_name" : "High fluorescence ratio"
                                },
                                {
                                "field_name": "hm_ret_he",
                                "nick_name" : "RET-He",
                                "full_name" : "Reticulocyte hemoglobin equivalent"
                                },
                                {
                                "field_name": "hm_rpi",
                                "nick_name" : "RPI",
                                "full_name" : "Reticulocyte Production Index"
                                },
                                {
                                "field_name": "hm_agg",
                                "nick_name" : "Auto Agg",
                                "full_name" : "Auto Agglutination"
                                },
                                {
                                "field_name": "hm_protein_refract",
                                "nick_name" : "PP",
                                "full_name" : "Plasma proteins"
                                },

                                //
                                {
                                "field_name": "hm_rmc",
                                "nick_name" : "Reticulocyte manaul count",
                                "full_name" : "Reticulocyte manaul count"
                                },
                                {
                                "field_name": "hm_agg1",
                                "nick_name" : "Auto Agg",
                                "full_name" : "Auto Agglutination"
                                },



                                {
                                "field_name": "bf_wbcbf",
                                "nick_name" : "WBC-BF",
                                "full_name" : "White blood cell (leukocyte) count"
                                },
                                {
                                "field_name": "bf_rbcbf",
                                "nick_name" : "RBC-BF",
                                "full_name" : "Red blood cell (erythrocyte) count"
                                },
                                {
                                "field_name": "bf_mn",
                                "nick_name" : "MN#",
                                "full_name" : "Mononuclear count"
                                },
                                {
                                "field_name": "bf_pmn",
                                "nick_name" : "PMN#",
                                "full_name" : "Polymorphonuclear count"
                                },
                                {
                                "field_name": "bf_mn1",
                                "nick_name" : "MN%",
                                "full_name" : "Mononuclear percent"
                                },
                                {
                                "field_name": "bf_pmn1",
                                "nick_name" : "PMN%",
                                "full_name" : "Polymorphonuclear percent"
                                },
                                {
                                "field_name": "bf_tcbf",
                                "nick_name" : "TC-BF",
                                "full_name" : "Total nucleated cell count"
                                },
                                {
                                "field_name": "bc_bun",
                                "nick_name" : "BUN",
                                "full_name" : "Blood urea nitrogen"
                                },
                                {
                                "field_name": "bc_creatinine",
                                "nick_name" : "CREA",
                                "full_name" : "Creatinine"
                                },
                                {
                                "field_name": "bc_uric",
                                "nick_name" : "URIC",
                                "full_name" : "Uric acid"
                                },
                                {
                                "field_name": "bc_cholesterol",
                                "nick_name" : "CHOL",
                                "full_name" : "Cholesterol"
                                },
                                {
                                "field_name": "bc_triglyceride",
                                "nick_name" : "TRIG",
                                "full_name" : "Triglycerides"
                                },
                                {
                                "field_name": "bc_protein_biuret",
                                "nick_name" : "TP",
                                "full_name" : "Total protein"
                                },
                                {
                                "field_name": "bc_albumin",
                                "nick_name" : "ALB",
                                "full_name" : "Albumin"
                                },
                                {
                                "field_name": "bc_glob",
                                "nick_name" : "Glob",
                                "full_name" : "Globulin"
                                },
                                {
                                "field_name": "bc_bilirubin_total",
                                "nick_name" : "TBIL",
                                "full_name" : "Total bilirubin"
                                },
                                {
                                "field_name": "bc_direct",
                                "nick_name" : "DBIL",
                                "full_name" : "Direct Bilirubin"
                                },
                                {
                                "field_name": "bc_ast_sgot",
                                "nick_name" : "AST",
                                "full_name" : "Aspartate aminotransferase"
                                },
                                {
                                "field_name": "bc_alt_sgpt",
                                "nick_name" : "ALT",
                                "full_name" : "Alanine aminotransferase"
                                },
                                {
                                "field_name": "bc_alk_phos",
                                "nick_name" : "ALP",
                                "full_name" : "Alkaline phosphatase"
                                },
                                {
                                "field_name": "bc_csf",
                                "nick_name" : "CSF",
                                "full_name" : "Cerebrospinal Fluid Protein"
                                },
                                {
                                "field_name": "bc_ggt",
                                "nick_name" : "GGT",
                                "full_name" : "Gamma-glutamyl transferase"
                                },
                                {
                                "field_name": "bc_calcium",
                                "nick_name" : "Ca",
                                "full_name" : "Calcium"
                                },
                                {
                                "field_name": "bc_phosphorus",
                                "nick_name" : "PHOS",
                                "full_name" : "Inorganic phosphorus"
                                },
                                {
                                "field_name": "bc_sodium",
                                "nick_name" : "Na",
                                "full_name" : "Sodium"
                                },
                                {
                                "field_name": "bc_potassium",
                                "nick_name" : "K",
                                "full_name" : "Potassium"
                                },
                                {
                                "field_name": "bc_chloride",
                                "nick_name" : "Cl",
                                "full_name" : "Chloride"
                                },
                                {
                                "field_name": "bc_cpk",
                                "nick_name" : "CK",
                                "full_name" : "Creatinine kinase"
                                },
                                {
                                "field_name": "bc_ammonia",
                                "nick_name" : "NH3",
                                "full_name" : "Ammonia"
                                },
                                {
                                "field_name": "bc_glucose",
                                "nick_name" : "GLU",
                                "full_name" : "Glucose"
                                },
                                // {
                                // "field_name": "ur_creatinine",
                                // "nick_name" : "UCRE",
                                // "full_name" : "Urine creatinine"
                                // },
                                // {
                                // "field_name": "bc_upro",
                                // "nick_name" : "UPRO",
                                // "full_name" : "Urine protein"
                                // },
                                {
                                "field_name": "bc_amylase",
                                "nick_name" : "AMYL",
                                "full_name" : "Amylase"
                                },
                                {
                                "field_name": "bc_crp",
                                "nick_name" : "CRP",
                                "full_name" : "C-reactive protein"
                                },
                                {
                                "field_name": "bc_sdma",
                                "nick_name" : "SDMA",
                                "full_name" : "Symmetric dimethylarginine"
                                },
                                {
                                "field_name": "bc_tt4",
                                "nick_name" : "TT4(T4)",
                                "full_name" : "Total Thyroxine"
                                },
                                {
                                "field_name": "sp_fructo",
                                "nick_name" : "FRU",
                                "full_name" : "Fructosamine"
                                },
                                {
                                "field_name": "bc_fru",
                                "nick_name" : "LAC",
                                "full_name" : "Lactate"
                                },
                                {
                                "field_name": "bc_lac",
                                "nick_name" : "LDH",
                                "full_name" : "Lactate dehydrogenase"
                                },
                                {
                                "field_name": "sp_lipase",
                                "nick_name" : "LIPA",
                                "full_name" : "Lipase"
                                },
                                {
                                "field_name": "bc_mg",
                                "nick_name" : "Mg",
                                "full_name" : "Magnesium"
                                },
                                {
                                "field_name": "bc_prog",
                                "nick_name" : "PROG",
                                "full_name" : "Progesterone"
                                },
                                {
                                "field_name": "bc_bileacid_fasting",
                                "nick_name" : "BA",
                                "full_name" : "Bile acids"
                                },
                                //
                                {
                                    "field_name": "bc_bileacid_post",
                                    "nick_name" : "BA(POST)",
                                    "full_name" : "Bile acids Postprandial"
                                },
                                {
                                    "field_name": "bc_bileacid_pre",
                                    "nick_name" : "BA(PRE)",
                                    "full_name" : "Bile acids Preprandial"
                                },




                                {
                                "field_name": "hom_t4",
                                "nick_name" : "cT4",
                                "full_name" : "Canine thyroxine"
                                },
                                {
                                "field_name": "hom_ctsh",
                                "nick_name" : "cTSH",
                                "full_name" : "Canine thyroid stimulating hormone"
                                },
                                {
                                "field_name": "hom_ctli",
                                "nick_name" : "cTLI",
                                "full_name" : "Canine trypsin-like immunoreactivity"
                                },
                                {
                                "field_name": "sp_phenobarb",
                                "nick_name" : "PHBR",
                                "full_name" : "Phenobarbitol"
                                },
                                {
                                "field_name": "hom_cotis",
                                "nick_name" : "Cortisol",
                                "full_name" : "Cortisol"
                                },
                                {
                                "field_name": "bg_ph",
                                "nick_name" : "pH",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_pco2",
                                "nick_name" : "pCO2",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_po2",
                                "nick_name" : "pO2",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_na",
                                "nick_name" : "Na",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_k",
                                "nick_name" : "K",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_ci",
                                "nick_name" : "Cl",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_ca",
                                "nick_name" : "iCa",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_hb",
                                "nick_name" : "Hb",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_hct",
                                "nick_name" : "HCT",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_hco3",
                                "nick_name" : "HCO3-act",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_be",
                                "nick_name" : "BE(B)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_ctco2",
                                "nick_name" : "ctCO2(P)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_pht",
                                "nick_name" : "pH(T)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_pco2t",
                                "nick_name" : "pCO2(T)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_po2t",
                                "nick_name" : "pO2(T)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_so2est",
                                "nick_name" : "sO2(est)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_ica",
                                "nick_name" : "iCa(7.4)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_glc",
                                "nick_name" : "Glc",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_lac",
                                "nick_name" : "Lac",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_temp",
                                "nick_name" : "Temperature",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_fio2",
                                "nick_name" : "FIO2",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_bp",
                                "nick_name" : "BP",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_hco3std",
                                "nick_name" : "HCO3-std",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_beecf",
                                "nick_name" : "BE(ecf)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_cna",
                                "nick_name" : "cNa+",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_ck",
                                "nick_name" : "cK+",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_cca2",
                                "nick_name" : "cCa2+",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_cci",
                                "nick_name" : "cCI-",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_cglc",
                                "nick_name" : "cGlc",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_clac",
                                "nick_name" : "cLac",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_ctbil",
                                "nick_name" : "ctBil",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_cthb",
                                "nick_name" : "ctHb",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_fhhb",
                                "nick_name" : "FHHb",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_fo2hb",
                                "nick_name" : "FO2Hb",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_fcohb",
                                "nick_name" : "FCOHb",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_fmethb",
                                "nick_name" : "FMetHb",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_so2",
                                "nick_name" : "sO2",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_ag",
                                "nick_name" : "AG",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_agk",
                                "nick_name" : "AG(K)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_chact",
                                "nick_name" : "cHCO3- act",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_chstd",
                                "nick_name" : "cHCO3- std",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_cbeecf",
                                "nick_name" : "cBE(ecf)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_cbeb",
                                "nick_name" : "CBE(B)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_cbb",
                                "nick_name" : "cBB",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_ctco2b",
                                "nick_name" : "ctCO2(B)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_bo2",
                                "nick_name" : "BO2",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_p50",
                                "nick_name" : "p50",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_p50t",
                                "nick_name" : "p50(T)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_p50st",
                                "nick_name" : "p50(st)	",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_po2fio2",
                                "nick_name" : "pO2/FiO2",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_cca2p",
                                "nick_name" : "cCa2+ (7.4)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_po2a",
                                "nick_name" : "pO2(A)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_po2at",
                                "nick_name" : "pO2(A)(T)	",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_po2aa",
                                "nick_name" : "pO2(A-a)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_po2aat",
                                "nick_name" : "pO2(A-a)(T)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_po2aa1",
                                "nick_name" : "pO2(a/A)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_po2aat1",
                                "nick_name" : "pO2(a/A)(T)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_ri",
                                "nick_name" : "RI",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_rit",
                                "nick_name" : "RI(T)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_cto2a",
                                "nick_name" : "ctO2(a)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_cto2b",
                                "nick_name" : "ct02(B)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_cto2v",
                                "nick_name" : "ctO2(v)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_cto2av",
                                "nick_name" : "ctO2(a-v)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_cto2ava",
                                "nick_name" : "ctO2([a-v]/a)",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_h",
                                "nick_name" : "Height",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_w",
                                "nick_name" : "Weight",
                                "full_name" : ""
                                },
                                {
                                "field_name": "bg_ptmp",
                                "nick_name" : "Patient's body temperature	",
                                "full_name" : ""
                                },
                                {
                                "field_name": "ol_17",
                                "nick_name" : "17-Hydroxy Progesterone",
                                "full_name" : "17-Hydroxy Progesterone"
                                },
                                {
                                "field_name": "hor_acth",
                                "nick_name" : "ACTH",
                                "full_name" : "Adrenocorticotrophic Hormone"
                                },
                                {
                                "field_name": "ol_afp",
                                "nick_name" : "AFP",
                                "full_name" : "Alpha- fetoprotein"
                                },
                                {
                                "field_name": "ol_aph1",
                                "nick_name" : "Alpha1 antitrypsin",
                                "full_name" : "Alpha1 antitrypsin"
                                },
                                {
                                "field_name": "ol_ana",
                                "nick_name" : "Anti Thrombin III",
                                "full_name" : "Anti Thrombin III"
                                },
                                {
                                "field_name": "ol_bm",
                                "nick_name" : "Bromide",
                                "full_name" : "Bromide"
                                },
                                {
                                "field_name": "ol_cp",
                                "nick_name" : "C -Peptide",
                                "full_name" : "C -Peptide"
                                },
                                {
                                "field_name": "ol_cctn",
                                "nick_name" : "Calcitonin",
                                "full_name" : "Calcitonin"
                                },
                                {
                                "field_name": "ol_ctcc1",
                                "nick_name" : "Cryptococcus Ag (Qualitative)",
                                "full_name" : "Cryptococcus Ag (Qualitative)"
                                },
                                {
                                "field_name": "ol_ctcc2",
                                "nick_name" : "Cryptococcus Ag (Semi Quantitative)",
                                "full_name" : "Cryptococcus Ag (Semi Quantitative)"
                                },
                                {
                                "field_name": "ol_ddim",
                                "nick_name" : "D-Dimer",
                                "full_name" : "D-Dimer"
                                },
                                {
                                "field_name": "sp_digoxin",
                                "nick_name" : "Digoxin (Digitalis)",
                                "full_name" : "Digoxin (Digitalis)"
                                },
                                {
                                "field_name": "ol_epo",
                                "nick_name" : "EPO",
                                "full_name" : "Erytropoietin level"
                                },
                                {
                                "field_name": "ol_e3",
                                "nick_name" : "E3",
                                "full_name" : "Estriol"
                                },
                                {
                                "field_name": "hor_estra",
                                "nick_name" : "E2",
                                "full_name" : "Estradiol"
                                },
                                {
                                "field_name": "ol_ferrt",
                                "nick_name" : "Ferritin",
                                "full_name" : "Ferritin"
                                },
                                {
                                "field_name": "ol_flat",
                                "nick_name" : "Folate",
                                "full_name" : "Folate in serum"
                                },
                                {
                                "field_name": "hor_freet4",
                                "nick_name" : "Free T4",
                                "full_name" : "Free thyroxine"
                                },
                                {
                                "field_name": "ol_gast",
                                "nick_name" : "Gastrin",
                                "full_name" : "Gastrin"
                                },
                                {
                                "field_name": "ol_gh",
                                "nick_name" : "GH",
                                "full_name" : "Growth homone"
                                },
                                {
                                "field_name": "ol_hbeab",
                                "nick_name" : "HBe Ab. ",
                                "full_name" : "Hepatitis B (HBe Ab.) "
                                },
                                {
                                "field_name": "ol_hbeag",
                                "nick_name" : "HBe Ag.",
                                "full_name" : "Hepatitis B (HBe Ag.)"
                                },
                                {
                                "field_name": "ol_hmct",
                                "nick_name" : "Hemoculture",
                                "full_name" : "Hemoculture"
                                },
                                {
                                "field_name": "ol_ha1c",
                                "nick_name" : "HA1C",
                                "full_name" : "Hemoglobin A1C"
                                },
                                {
                                "field_name": "ol_histoab",
                                "nick_name" : "Histoplasmosis Ab.",
                                "full_name" : "Histoplasmosis Ab."
                                },
                                {
                                "field_name": "ol_igf1",
                                "nick_name" : "IGF1",
                                "full_name" : "IGF1"
                                },
                                {
                                "field_name": "hor_insulin",
                                "nick_name" : "Insulin",
                                "full_name" : "Insulin"
                                },
                                {
                                "field_name": "ol_mags",
                                "nick_name" : "Magnesium (Serum)",
                                "full_name" : "Magnesium (Serum)"
                                },
                                {
                                "field_name": "ol_magu",
                                "nick_name" : "Magnesium (Urine)",
                                "full_name" : "Magnesium (Urine)"
                                },
                                {
                                "field_name": "ol_mcr",
                                "nick_name" : "Mercury",
                                "full_name" : "Mercury"
                                },
                                {
                                "field_name": "ol_mtn",
                                "nick_name" : "Meta&Normetanephrine (Urine)",
                                "full_name" : "Meta&Normetanephrine (Urine)"
                                },
                                {
                                "field_name": "hor_pth",
                                "nick_name" : "iPTH",
                                "full_name" : "Parathyroid Hormone, Intact "
                                },
                                {
                                "field_name": "ol_ptt",
                                "nick_name" : "PTT",
                                "full_name" : "Partial Thromboplastin time"
                                },
                                {
                                "field_name": "hor_pro",
                                "nick_name" : "P4",
                                "full_name" : "Progesterone"
                                },
                                {
                                "field_name": "ol_prolt",
                                "nick_name" : "Prolactin",
                                "full_name" : "Prolactin"
                                },
                                {
                                "field_name": "ol_pt",
                                "nick_name" : "PT",
                                "full_name" : "Prothrombin Time"
                                },
                                {
                                "field_name": "ol_rn",
                                "nick_name" : "Renin",
                                "full_name" : "Renin"
                                },
                                {
                                "field_name": "ol_rbl",
                                "nick_name" : "Rubella Ab. IgG",
                                "full_name" : "Rubella Ab. IgG"
                                },
                                {
                                "field_name": "ol_sro",
                                "nick_name" : "Serum Osmolality",
                                "full_name" : "Serum Osmolality"
                                },
                                {
                                "field_name": "ol_t3",
                                "nick_name" : "T3",
                                "full_name" : "Triiodothyronine"
                                },
                                {
                                "field_name": "ol_antit",
                                "nick_name" : "Anti Thrombin III",
                                "full_name" : "Anti Thrombin III"
                                },
                                {
                                "field_name": "hor_tes",
                                "nick_name" : "Testosterone",
                                "full_name" : "Testosterone"
                                },
                                {
                                "field_name": "hor_urin_costisol",
                                "nick_name" : "Urine free cortisol",
                                "full_name" : "Urine free cortisol"
                                },

                                 



                                {
                                "field_name": "ol_tt",
                                "nick_name" : "TT",
                                "full_name" : "Thrombin Time"
                                },
                                {
                                "field_name": "ol_tyab",
                                "nick_name" : "Thyroglobulin Ab.",
                                "full_name" : "Thyroglobulin Ab."
                                },
                                {
                                "field_name": "ol_tfr1",
                                "nick_name" : "Transferrin",
                                "full_name" : "Transferrin"
                                },
                                {
                                "field_name": "ol_tfr2",
                                "nick_name" : "Transferrin saturation",
                                "full_name" : "Transferrin saturation"
                                },
                                {
                                "field_name": "ol_tpt",
                                "nick_name" : "Troponin T",
                                "full_name" : "Troponin T"
                                },
                                {
                                "field_name": "ol_uro",
                                "nick_name" : "Urine Osmolality",
                                "full_name" : "Urine Osmolality"
                                },
                                {
                                "field_name": "ol_uvma",
                                "nick_name" : "Urine VMA",
                                "full_name" : "Urine VMA"
                                },
                                {
                                "field_name": "ol_vb12",
                                "nick_name" : "Vitamin B12",
                                "full_name" : "Vitamin B12"
                                },

                                // 

                                {
                                    "field_name": "hor_cat4",
                                    "nick_name" : "Canine T4",
                                    "full_name" : "Canine T4"
                                },
                                {
                                    "field_name": "hor_uccr",
                                    "nick_name" : "UCCR",
                                    "full_name" : "UCCR"
                                },
                                {
                                    "field_name": "hor_fsh",
                                    "nick_name" : "FSH",
                                    "full_name" : "FSH"
                                },
                                {
                                    "field_name": "hor_lh",
                                    "nick_name" : "LH",
                                    "full_name" : "LH"
                                },
                                {
                                    "field_name": "hor_catsh",
                                    "nick_name" : "TSH",
                                    "full_name" : "TSH"
                                }  


                            ] ,

         
 
        
      

    },



    getters: {
    },

    mutations: {


         



        setCBCImages (state,CBCImages){
            state.CBCImages = CBCImages
        },



        set_dvmAutocomplete(state,dvmAutocomplete){
            state.dvmAutocomplete = dvmAutocomplete
        },
        
        setDVMSelected (state,dvmSelected){
            state.dvmSelected = dvmSelected
        },
  
  
  
        setArrDVM (state,arrDVM){
            state.arrDVM = arrDVM
        },




        // arrUsers : [],
        // userSelected : null,
        // userAutoComplete : '',


        set_userAutocomplete(state,userAutoComplete){
            state.userAutoComplete = userAutoComplete
        },
        setUserSelected (state,userSelected){
            state.userSelected = userSelected
        },
        setArrUsers (state,arrUsers){
            state.arrUsers = arrUsers
        },
        










        // setLabNoToEdit(state,labNoToEdit){
        //     state.labNoToEdit = labNoToEdit
        // },



        setCommentNote(state,commentNote){
            state.commentNote = commentNote
        },

     


        setDiagnosisNote(state,diagnosisNote){
            state.diagnosisNote = diagnosisNote
        },

        setResultRemark(state,resultRemark){
            state.resultRemark = resultRemark
        },




        setSingni_phy(state,singni_phy){
            state.singni_phy = singni_phy
        },


        setTentative_dx(state,tentative_dx){
            state.tentative_dx = tentative_dx
        },

        setTest_desire(state,test_desire){
            state.test_desire = test_desire
        },

        setSpecial_rq(state,special_rq){
            state.special_rq = special_rq
        },


        setDataToEdit_ManuallyLabAutomate(state,dataToEdit_ManuallyLabAutomate){
            state.dataToEdit_ManuallyLabAutomate = dataToEdit_ManuallyLabAutomate
        },

        setUAParams(state,UAParams){
            state.UAParams = UAParams
        },

        setUAExtend(state,UAExtend){
            state.UAExtend = UAExtend
        },

        setDataModelMNLABAutomate(state,dataModelMNLABAutomate){
            state.dataModelMNLABAutomate = dataModelMNLABAutomate
        },


        setOpdSelected(state,opdSelected){
            state.opdSelected = opdSelected
        },


        // setLabParam(state,labParam){
        //     state.labParam = labParam
        // },

        setBlMor(state,blMor){
            state.blMor = blMor
        },

        setBlMorSelected(state,blMorSelected){
            state.blMorSelected = blMorSelected
        },

         

         

        setBlParasiteDetailSelected (state,blParasiteDetailSelected){
            state.blParasiteDetailSelected = blParasiteDetailSelected
        }, 




        setBlParasiteMaterSelected (state,blParasiteMaterSelected){
            state.blParasiteMaterSelected = blParasiteMaterSelected
        }, 


        setBlParasiteMaterSelect (state,blParasiteMaterSelect){
            state.blParasiteMaterSelect = blParasiteMaterSelect
        }, 
         
        setBlParasiteParam(state,blParasiteParam){
            state.blParasiteParam = blParasiteParam
        }, 



        setLab_HIS_LIS_Mapping(state,lab_HIS_LIS_Mapping){
            state.lab_HIS_LIS_Mapping = lab_HIS_LIS_Mapping
        },

        setModeManuallyLabAutomate(state,modeManuallyLabAutomate){
           state.modeManuallyLabAutomate = modeManuallyLabAutomate
        }
  

    },

    actions: {
       

        
        // Dev experiment: HTTP-complete actions; legacy actions below are unchanged.
        fetchLab_his_lis_mappingSequential({
          commit
        }) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`;
          return axios.post(`${getBaseURLforBackEnd()}/api/getlab_his_lis_mapping`, getConfigAxios()).then(res => {
            commit('setLab_HIS_LIS_Mapping', res.data);
            return res.data;
          });
        },

        fetchArrUsersSequential({
          commit
        }) {
          commit('setArrUsers', []);
          axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`;
          return axios.get(`${getBaseURLforBackEnd()}/api/listofuser`, getConfigAxios()).then(res => {
            commit('setArrUsers', res.data);
            return res.data;
          });
        },
fetchOnlyCBCImages({commit},ln){
            const datTo = {
                "ln" : ln
            }
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/loadimagescbc_by_idlab`,datTo,getConfigAxios())
                    .then((res)=>{
                        commit('setCBCImages',res.data)
                        resolve(res.data)
                    })
                    .catch(err =>{
                        reject(err)
                    })
            })
        } ,




        // fetchNewModelManulaLABAutomate({commit}){
        //     // console.log("fetchNewModelManulaLABAutomate")
        //     return new Promise((resolve,reject) => {
        //         axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`
        //         axios.post(`${getBaseURLforBackEnd()}/api/get_new_model_manual_lab_automate`,getConfigAxios())
        //             .then((res)=>{
        //                 // console.log(res)
        //                 commit('setLabParam',res.data)
        //                 resolve(res.data)
        //             })
        //             .catch(err =>{
        //                 reject(err)
        //             })
        //     })
        // } ,


        fetchLab_his_lis_mapping({commit}){
    
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`
                // axios.post(`${getBaseURLforBackEnd()}/api/getlab_his_lis_mapping`,getConfigAxios())
                axios.post(`${getBaseURLforBackEnd()}/api/getlab_his_lis_mapping`,getConfigAxios())
                    .then((res)=>{
                        // console.log(res)
                        commit('setLab_HIS_LIS_Mapping',res.data)
                        resolve(res.data)
                    })
                    .catch(err =>{
                        reject(err)
                    })
            })
        } ,





        fetchBlMor({commit}){
            // console.log("fetchNewModelManulaLABAutomate")
            // init before fetch new
            commit('setBlMor',[])
            commit('setBlMorSelected',[])
             
            //
            const datTo = {   
                                "admin" :  false
                            }
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/list_of_blmor`,datTo,getConfigAxios())
                    .then((res)=>{
                        // console.log(res)
                        commit('setBlMor',res.data)
                        resolve(res.data)
                    })
                    .catch(err =>{
                        reject(err)
                    })
            })
        } ,



        fetchBlParasite({commit}){
            // console.log("fetchNewModelManulaLABAutomate")
            // init before fetch new
            commit('setBlParasiteParam',[])
           
             
            //
            const datTo = {   
                                "admin" :  false
                            }
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/list_of_bl_parasite`,datTo,getConfigAxios())
                    .then((res)=>{
                        // console.log(res)
                        // fill result selected  and remark
                        res.data.map((element) => {
                             element.selectedValue = ""
                             element.amount = ""
                             element.unit = ""
                             element.remark = ""
                             return element
                         });
                        commit('setBlParasiteParam',res.data)
                        if(res.data.length>0){
                            commit('setBlParasiteMaterSelect',res.data[0].result_dat_aval.id) 
                        }
                        resolve(res.data)
                    })
                    .catch(err =>{
                        reject(err)
                    })
            })
        } ,



        fetchUAExtend({commit}){
            // console.log("fetchNewModelManulaLABAutomate")
            // init before fetch new
            commit('setUAExtend',[])
            //
            // const datTo = {   
            //                     "admin" :  false
            //                 }
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/listof_ua_extend`,getConfigAxios())
                    .then((res)=>{
                        commit('setUAExtend',res.data)
                        resolve(res.data)
                    })
                    .catch(err =>{
                        reject(err)
                    })
            })
        } ,



        fetchUAParams({commit}){
         
            commit('setUAParams',[])
       
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/get_ua_datamodel`,getConfigAxios())
                    .then((res)=>{
                        // console.log(res.data)
                        commit('setUAParams',res.data)
                        resolve(res.data)
                    })
                    .catch(err =>{
                        reject(err)
                    })
            })
        } ,

         
        fetchArrDVM({commit}){
         
            commit('setArrDVM',[])
       
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/listofdvm`,getConfigAxios())
                    .then((res)=>{
                        commit('setArrDVM',res.data)
                        resolve(res.data)
                    })
                    .catch(err =>{
                        reject(err)
                    })
            })
        } ,


        fetchArrUsers({commit}){
         
            commit('setArrUsers',[])
       
            return new Promise((resolve,reject) => {
                axios.defaults.headers.common['Authorization'] = `Bearer ${master_data.state.access_token}`
                axios.get(`${getBaseURLforBackEnd()}/api/listofuser`,getConfigAxios())
                    .then((res)=>{
                        commit('setArrUsers',res.data)
                        resolve(res.data)
                    })
                    .catch(err =>{
                        reject(err)
                    })
            })
        } ,


         







       


    }
}